import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { checkToken, loginConfirmCode, loginUser, sendRefresh, sendRefreshFinish } from './authActions'
import { RolesType } from '../../utils/roles';

const userToken = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : null;

const defaultUserInfo = {
    // user_id: null,
    // name: ''
    user_avatar: null,
}
type UserInfoType = {
    // name: string,
    // user_id: number | null,
    user_avatar: string | null,
}
type LoginType = {
    loading: boolean, // auth
    loadingRefresh: any, // forgot-password
    loadingConfirm: any,
    userInfo: UserInfoType,
    token: any,
    error: any, // auth
    errorConfirm: any, // auth
    errorRefresh: any,// forgot-password
    success: boolean
    roles: RolesType | undefined
}
const initialState: LoginType = {
    loading: false,
    loadingRefresh: false,
    loadingConfirm: false,
    userInfo: defaultUserInfo,
    token: userToken, // for storing the JWT
    error: null,
    errorConfirm: null,
    errorRefresh: null,
    success: false, // for monitoring the registration process.
    roles: undefined
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action?.payload
        },
        clearErrorsLogin: (state,) => {
            state.error = null
        },
        clearErrorsLoginConfirm: (state,) => {
            state.errorConfirm = null
        },
        clearErrorsRefresh: (state,) => {
            state.errorRefresh = null
        },
        removeToken: (state, action?: PayloadAction<undefined>) => {
            state.userInfo = defaultUserInfo
            state.token = ''
        },
        setUserInfo: (state, action: PayloadAction<UserInfoType>) => {
            state.userInfo = action.payload
        },
        setRoles: (state, action: PayloadAction<RolesType>) => {
            state.roles = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(sendRefresh.pending, (state) => {
            state.loadingRefresh = true
            state.errorRefresh = null
        })
        builder.addCase(sendRefresh.fulfilled, (state) => {
            state.loadingRefresh = false
            state.errorRefresh = null
        })
        builder.addCase(sendRefresh.rejected, (state, { payload }) => {
            state.loadingRefresh = false
            state.errorRefresh = payload
        })

        // ==
        builder.addCase(loginUser.pending, (state) => {
            state.loading = true
            state.error = null
        })
        builder.addCase(loginUser.fulfilled, (state, { payload }) => {
            state.loading = false
            // state.token = payload.token.token
            state.success = true
            state.error = null
            // localStorage.setItem('userToken', payload.token.token)
        })
        builder.addCase(loginUser.rejected, (state, { payload }) => {
            state.loading = false
            state.error = payload
        })
        // ==
        builder.addCase(loginConfirmCode.pending, (state) => {
            state.loadingConfirm = true
            state.errorConfirm = null
        })
        builder.addCase(loginConfirmCode.fulfilled, (state, { payload }) => {
            state.loadingConfirm = false
            // state.token = payload.token.token
            state.success = true
            state.errorConfirm = null
            // localStorage.setItem('userToken', payload.token.token)
        })
        builder.addCase(loginConfirmCode.rejected, (state, { payload }) => {
            state.loadingConfirm = false
            state.errorConfirm = payload
        })
        // ==

        builder.addCase(checkToken.pending, (state) => {
            state.loading = true
            state.error = null
        })
        builder.addCase(checkToken.fulfilled, (state, { payload }) => {
            state.loading = false
            state.error = null
            state.success = true
        })
        builder.addCase(checkToken.rejected, (state, { payload }) => {
            state.loading = false
            state.error = payload
            window.location.href = '/auth'
            state.token = ''
            localStorage.setItem('userToken', '')
        })
    }
})
export const { removeToken, setUserInfo, clearErrorsLogin, clearErrorsRefresh, clearErrorsLoginConfirm, setRoles, setToken } = authSlice.actions

export default authSlice.reducer